import state from "./state";
import actions from "./actions";
import actions_submissions from "./actions_submissions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  namespaced: true,
  state,
  actions: Object.assign({}, actions, actions_submissions),
  mutations,
  getters
};
